<ng-template [ngIf]="config?.showCard">
    <div class="card card-warning with-arrow">
        <div class="card-arrow"></div>
        <h6 class="card-header card-title">
            <i class="fas fa-exclamation-triangle"></i> Atenção
        </h6>
        <div class="card-body pb-3">
            <p class="card-text">{{configCliente?.mensagemDestaqueIpi}}</p>
        </div>                       
    </div>
</ng-template>